<template >
  <div>
    <h3>报表视图</h3>
    <el-card>
      <el-row>
        <el-col :span="12">
          <div id="main" style="width: 500px;height:300px;"></div>
        </el-col>
        <el-col :span="12">
          <div id="mainMac" style="width: 500px;height:300px;"></div>
        </el-col>
      </el-row>

      <el-row>

        <el-col :span="12">
          <div id="myChartproduct" style="width: 500px;height:300px;"></div>
        </el-col>
         <el-col :span="12">
          <div id="myChartGuest" style="width: 500px;height:300px;"></div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import _ from 'lodash'
export default {
  data() {
    return {
      query_data: {
        data1: [],
        title1: [],
        data2: [],
        title2: [],
        data3: [],
        title3: [],
        data4: [],
        title4: []
      }
    };
  },
  created() {
     
  },
  async mounted() {
    var myChart = echarts.init(document.getElementById('main'));
    var myChartMac = echarts.init(document.getElementById('mainMac'));
    var myChartproduct = echarts.init(document.getElementById('myChartproduct'));
    var myChartGuest = echarts.init(document.getElementById('myChartGuest'));
    var option = {
      title: {
        text: '订单按月统计实时数据'
      },
      tooltip: {},
      legend: {
        data: ['销量']
      },
      xAxis: {
        data: this.query_data.title1
      },
      yAxis: {},
      series: [
        {
          name: '销量',
          type: 'bar',
          data: this.query_data.data1
        }
      ]
    };
    var optionMac = {
      title: {
        text: '支付统计',
        subtext: '',
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 10,
        data: this.query_data.title2
      },
      series: [
        {
          name: '详细',
          type: 'pie', // 饼图类型
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            }
          }, 
          labelLine: {
            show: false
          },

           data: this.query_data.data2
        }
      ]
    };
    // console.log(this.query_data.data2)
    var optionproduct = {
      title: {
        text: '商品统计',
        subtext: '',
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        // data: ['2000.00元', '3000.00元', '5000.00元', '8000.00元', '12000.00元']
         data: this.query_data.title3
      },
      series: [
        {
          name: '详细',
          type: 'pie', // 饼图类型
          radius: '55%',
          center: ['50%', '60%'],
            data: this.query_data.data3,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
// -------------004-------------------------
    var optionGuest = {
      title: {
        text: '客户统计',
        subtext: '',
        left: 'center'
      },
      xAxis: {
        type: 'category',
        data: this.query_data.title4
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: this.query_data.data4,
          type: 'line'
          // 折线图类型
        }
      ]
    };

        const { data: res } = await this.$http.get('get_api', {
                params: {
                  C_type: 'baobiao_query',
                  query: '',
                  pageNum: 1,
                  pageSize: 10
                }
              })
             console.log(res)
         //  this.query_data = res
     //  return
      // 混合数据以便显示
          JSON.parse(res.data1).forEach(item => { this.query_data.data1.push(item.data) })
          JSON.parse(res.title1).forEach(item => { this.query_data.title1.push(item.title) })
          _.merge(this.query_data.data1, option.series[0].data)
          _.merge(this.query_data.title1, option.xAxis.data)

          this.query_data.data2 = JSON.parse(res.data2)
           _.merge(optionMac.series[0].data, this.query_data.data2)

           this.query_data.data3 = JSON.parse(res.data3)
           _.merge(optionproduct.series[0].data, this.query_data.data3)
           _.merge(optionproduct.legend.data, this.query_data.data3)

          JSON.parse(res.data4).forEach(item => { this.query_data.data4.push(item.data) })
          JSON.parse(res.title4).forEach(item => { this.query_data.title4.push(item.title) })

          _.merge(this.query_data.data4, optionGuest.series.data)
          _.merge(this.query_data.title4, optionGuest.xAxis.data)

  // console.log(this.query_data)
    myChart.setOption(option);
    myChartMac.setOption(optionMac);

    myChartGuest.setOption(optionGuest);
    myChartproduct.setOption(optionproduct);
  },
  methods: {

  }
};
</script>
